export default [
  {
    path: '/mobile/delivery/detail/:vehiclePolicyId/:phone',
    component: () => import('@/views/mobile/DeliveryDetail'),
    props: true
  },
  {
    path: '/mobile/delivery/list/:phone/:type',
    component: () => import('@/views/mobile/DeliveryList'),
    props: true
  }
]
